import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, message, Alert, Skeleton } from "antd";
import { API_URI } from "../../constant/Config";
import {t} from '../../constant/i18n';

const UpdateMemberAdhesion = ({ value }) => {
    const [memberData, setMemberData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showRenewalPrompt, setShowRenewalPrompt] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const token = localStorage.getItem("membre_token");

    useEffect(() => {
        const updateMember = async () => {
            setLoading(true);
            try {
                const response = await axios.post(`${API_URI}/api_member/data_member`, value, {
                    headers: { Authorization: token },
                });
                setMemberData(response.data.data_membre);
                checkRenewal(response.data.data_membre);
            } catch (error) {
                message.error(t('memberAdhesion.updateError'));
            }
            setLoading(false);
        };

        updateMember();
    }, [value, token]);

    const checkRenewal = (data) => {
        if (data.getGpMembrecolMembreHonoraire === 1 && !data.isValidRenewAdhesion) {
            setShowRenewalPrompt(true);
        }
    };

    const renewAdhesion = async () => {
        try {
            const response = await axios.post(`${API_URI}/api_member/renew-adhesion-member`, { data_membre: memberData }, {
                headers: { Authorization: token },
            });
            if (response.status === 200) {
                setResponseMessage(response.data.message);
                message.success(response.data.message);
                setShowRenewalPrompt(false);
            } else {
                message.error(response.data.message || t('memberAdhesion.renewError'));
            }
        } catch (error) {
            message.error(t('memberAdhesion.networkError'));
        }
    };

    return (
        <div style={{ maxWidth: "500px", marginLeft: "0" }}>
            {loading ? <Skeleton active /> : null}
            {showRenewalPrompt && (
                <Alert
                    message={t('memberAdhesion.confirmationRequired')}
                    description={
                        <>
                            <p>{t('memberAdhesion.adhesionValidity')}</p>
                            <Button type="primary" onClick={renewAdhesion} style={{ marginTop: "10px" }}>
                                {t('memberAdhesion.renewAdhesion')}
                            </Button>
                        </>
                    }
                    type="info"
                    showIcon
                    style={{ maxWidth: "500px", margin: "20px 0" }}
                />
            )}
            {responseMessage && (
                <Alert
                    message={responseMessage}
                    type="success"
                    showIcon
                    style={{ maxWidth: "500px", marginTop: "10px" }}
                />
            )}
        </div>
    );
};

export default UpdateMemberAdhesion;
